import { Link } from "react-router-dom";
import { Clock, MapPin, Users, CheckCircle2, AlertTriangle, PoundSterling, ChevronRight } from "lucide-react";

export const TONE = {
  green: { c: "#22C55E", bg: "rgba(34,197,94,0.10)" },
  amber: { c: "#FF9F1C", bg: "rgba(255,159,28,0.10)" },
  red: { c: "#FF4500", bg: "rgba(255,69,0,0.12)" },
  muted: { c: "#737373", bg: "rgba(115,115,115,0.10)" },
};

export function StatusPill({ tone = "green", children, testid }) {
  const t = TONE[tone] || TONE.muted;
  return (
    <span data-testid={testid} className="inline-flex items-center gap-1.5 px-2.5 py-1 text-[10px] font-bold uppercase tracking-[0.12em] rounded-full"
      style={{ color: t.c, background: t.bg, boxShadow: `inset 0 0 0 1px ${t.c}40` }}>
      <span className="w-1.5 h-1.5 rounded-full" style={{ background: t.c }} />{children}
    </span>
  );
}

export function Meta({ icon: Icon, children }) {
  return <span className="inline-flex items-center gap-1.5 text-xs text-[#A3A3A3]"><Icon className="w-3.5 h-3.5 text-[#525252]" />{children}</span>;
}

// Shared session card: sporty, left status rail, one primary line + meta row + badges.
export function ScheduleCard({ to, tone = "green", title, when, meta = [], pills = [], footer, dim = false, testid, highlight = false }) {
  const t = TONE[tone] || TONE.muted;
  const Wrap = to ? Link : "div";
  return (
    <Wrap to={to} data-testid={testid}
      className={`group relative block bg-[#111111] border border-[#1F1F1F] rounded-xl pl-5 pr-4 py-4 transition-[transform,border-color,background-color] duration-200 hover:-translate-y-0.5 hover:border-[#333] hover:bg-[#141414] ${dim ? "opacity-70" : ""} ${highlight ? "ring-1 ring-[#FF4500]/60" : ""}`}>
      <span className="absolute left-0 top-3 bottom-3 w-1 rounded-full" style={{ background: t.c }} />
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <div className="text-[15px] font-semibold text-white truncate">{title}</div>
          <div className="mt-0.5 text-sm text-[#E5E5E5] inline-flex items-center gap-1.5"><Clock className="w-3.5 h-3.5 text-[#CCFF00]" />{when}</div>
        </div>
        {to && <ChevronRight className="w-4 h-4 text-[#525252] group-hover:text-white transition-colors shrink-0 mt-1" />}
      </div>
      {meta.length > 0 && <div className="mt-3 flex flex-wrap gap-x-4 gap-y-1.5">{meta}</div>}
      {pills.length > 0 && <div className="mt-3 flex flex-wrap gap-2">{pills}</div>}
      {footer}
    </Wrap>
  );
}

export { MapPin, Users, CheckCircle2, AlertTriangle, PoundSterling };
